module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_01.7e07e75d.jpg";